import PropTypes from 'prop-types';
import React from 'react';

import Button, { ButtonAppearance } from '../Button';

import { SocialNetwork } from '../../../shared/constants/Enums';

const share = shareUrl => {
  if (typeof window !== 'undefined') {
    window.open(shareUrl, '_blank');
  }
};

const getShareUrl = ({ shareAPI, pageUrl, articleName }) => {
  const encodedUrl = encodeURIComponent(pageUrl);

  return shareAPI
    .replace('$1', encodedUrl)
    .replace('$2', articleName ? encodeURIComponent(articleName) : '');
};

export const SocialLink = ({ medium, pageUrl, articleName }) => {
  if (!medium || !pageUrl) {
    return null;
  }

  const { shareAPI, link, icon, ...rest } = SocialNetwork[medium];
  const shareUrl = getShareUrl({ shareAPI, pageUrl, articleName });

  return (
    <Button
      {...rest}
      appearance={ButtonAppearance.CIRCULAR}
      onClick={() => share(shareUrl)}
    >
      {icon}
    </Button>
  );
};

SocialLink.propTypes = {
  /**
   * Name of the current post.
   */
  articleName: PropTypes.string,
  /**
   * Choosen medium (Facebook, Twitter or LinkedIn).
   */
  medium: PropTypes.string.isRequired,
  /**
   * Url of the current page.
   */
  pageUrl: PropTypes.string.isRequired,
};
